import { fontFamilies, s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives/types';

type DestructiveActionButtonMeasureSx = {
  minWidth?: { sm: string };
  width?: { sm: string };
  whiteSpace?: 'nowrap';
};

export const projectSettingsConfirmationCodeSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: fontFamilies.mono,
  backgroundColor: 'action.hover',
  borderRadius: s('xxs'),
  pl: s('sm'),
  pr: s('xs'),
};

export const projectSettingsDestructiveActionRowSx: SxProps<Theme> = {
  gap: { xs: s('sm'), sm: s('md') },
};

export const projectSettingsDestructiveDescriptionCellSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

const projectSettingsDestructiveActionButtonBaseSx: SxProps<Theme> = {
  mt: { xs: s('sm'), sm: 0 },
  borderColor: 'error.main',
  color: 'error.main',
  '&:hover': {
    borderColor: 'error.main',
    color: 'error.main',
    backgroundColor: 'action.hover',
  },
};

export const buildProjectSettingsDestructiveActionButtonSx = (
  measureSx: DestructiveActionButtonMeasureSx,
): SxProps<Theme> => [projectSettingsDestructiveActionButtonBaseSx, measureSx];
